var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visitItem.canRecall)?_c('v-btn',{attrs:{"small":"","depressed":"","min-width":"0","color":_vm.buttonColor,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.reCall}},[_vm._v("Gensend")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }